import {
    ClassifierResultsToWrite,
    ExtendedMetadataToWrite,
    StepVariables,
} from "./LLMExecutorExecutionResult";

export enum TestLLMClassifierErrorType {
    InternalServiceError = 1,
    NoResults,
    ResultOutOfRange,
    Cancelled,
}

export interface TestLLMClassifierExceptionMetadata {
    exceptionType?: string;
    ExceptionType?: string;
    message: string;
    Message?: string;
    innerExceptionMessage?: string;
    InnerExceptionMessage?: string;
    fullException?: string;
    FullException?: string;
}

export interface TestLLMClassifierInternalServiceError {
    type: TestLLMClassifierErrorType.InternalServiceError;
    metadata: TestLLMClassifierExceptionMetadata;
}

/**
 * Work for this conversation was cancelled by something below the platform -- in practice the Azure
 * OpenAI client's network timeout. Distinct from the user cancelling the test, which aborts the
 * whole request instead of producing per-conversation errors.
 */
export interface TestLLMClassifierCancelledError {
    type: TestLLMClassifierErrorType.Cancelled;
    metadata: TestLLMClassifierExceptionMetadata;
}

export interface TestLLMClassifierNoResultsError {
    type: TestLLMClassifierErrorType.NoResults;
    metadata: {
        stepVariables: StepVariables;
        classifierResultsToWrite: ClassifierResultsToWrite;
        extendedMetadataToWrite: ExtendedMetadataToWrite;
    };
}

export interface TestLLMClassifierResultOutOfRangeError {
    type: TestLLMClassifierErrorType.ResultOutOfRange;
    metadata: {
        allowedResults: string[];
        actualResult: string;
        reasoning?: string;
        classifierResultsToWrite?: ClassifierResultsToWrite;
        extendedMetadataToWrite?: ExtendedMetadataToWrite;
    };
}

export type TestLLMClassifierError = {
    message: string;
} & (
    | TestLLMClassifierInternalServiceError
    | TestLLMClassifierNoResultsError
    | TestLLMClassifierResultOutOfRangeError
    | TestLLMClassifierCancelledError
);
